export const CLINICIAN_SIGNATURE_PRESENTATION = Object.freeze({
  widthPx: 160,
  heightPx: 68,
  nudgeYPx: 2,
});

export const DOCTOR_STAMP_PRESENTATION = Object.freeze({
  sizePx: 96,
  nudgeYPx: 2,
  viewBox: "0 0 100 100",
  outerRingRadius: 48.5,
  innerRingRadius: 33.5,
  outerRingOpacity: 0.35,
  innerRingOpacity: 0.25,
  ringColor: "rgb(24,50,119)",
  textColor: "rgb(24,50,119)",
  textOpacity: 0.9,
  fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
});

export function formatDoctorStampName(name = "") {
  const value = String(name).trim();
  if (!value) return "PRESCRIBER";
  return value.length > 26 ? `${value.slice(0, 24)}…` : value;
}

function escapeXml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&apos;");
}

export function createDoctorStampOverlayMarkup({
  doctorName,
  regNo,
  idPrefix = "doctor-stamp",
  isDark = false,
} = {}) {
  const presentation = DOCTOR_STAMP_PRESENTATION;
  const topArcId = `${idPrefix}-arc-top`;
  const bottomArcId = `${idPrefix}-arc-bottom`;
  const ringColor = isDark ? "rgb(138,149,171)" : presentation.ringColor;
  const textColor = isDark ? "rgb(181,190,206)" : presentation.textColor;
  const outerOpacity = isDark ? 0.55 : presentation.outerRingOpacity;
  const innerOpacity = isDark ? 0.38 : presentation.innerRingOpacity;
  const name = escapeXml(formatDoctorStampName(doctorName).toUpperCase());
  const registration = escapeXml(String(regNo || "").replace(/\s+/g, " ").trim());

  return `
    <defs>
      <path id="${escapeXml(topArcId)}" d="M 8 50 A 42 42 0 0 1 92 50" />
      <path id="${escapeXml(bottomArcId)}" d="M 8 50 A 42 42 0 0 0 92 50" />
    </defs>
    <circle cx="50" cy="50" r="${presentation.outerRingRadius}" fill="none" stroke="${ringColor}" stroke-opacity="${outerOpacity}" stroke-width="1.5" />
    <circle cx="50" cy="50" r="${presentation.innerRingRadius}" fill="none" stroke="${ringColor}" stroke-opacity="${innerOpacity}" stroke-width="1.5" />
    <text dy="3.5" font-family="${presentation.fontFamily}" font-size="7" letter-spacing="0.6" fill="${textColor}" fill-opacity="${presentation.textOpacity}">
      <textPath href="#${escapeXml(topArcId)}" startOffset="50%" text-anchor="middle">${name}</textPath>
    </text>
    <text dy="2" font-family="${presentation.fontFamily}" font-size="7" letter-spacing="0.8" fill="${textColor}" fill-opacity="${presentation.textOpacity}">
      <textPath href="#${escapeXml(bottomArcId)}" startOffset="50%" text-anchor="middle">${registration}</textPath>
    </text>
  `;
}
